'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId, MarketId } from '@morpho-org/blue-sdk';
import { useDialogContext } from '@morpho-org/ui-v6/contexts';
import { Icon } from '@repo/ui';
import { Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui';
import { Alert, ShieldCheck } from '@repo/ui/icons';
import { memo } from 'react';
import { AutoDeleverageDialog } from '../../AutoDeleverage';
import { useAutoDeleverage } from '../hooks/useAutoDeleverage';
interface AutoDeleverageButtonProps {
  marketId: MarketId;
  chainId: ChainId;
  onOpen?: () => void;
}
export const AutoDeleverageButton = t0 => {
  const $ = _c(19);
  const {
    marketId,
    chainId,
    onOpen
  } = t0;
  const {
    toggleDialog
  } = useDialogContext();
  const {
    status,
    refetchAll
  } = useAutoDeleverage(marketId, chainId);
  let t1;
  if ($[0] !== chainId || $[1] !== marketId || $[2] !== onOpen || $[3] !== toggleDialog) {
    t1 = () => {
      onOpen?.();
      toggleDialog(<AutoDeleverageDialog marketId={marketId} chainId={chainId} toEnable={false} />);
    };
    $[0] = chainId;
    $[1] = marketId;
    $[2] = onOpen;
    $[3] = toggleDialog;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const openAutoDeleverageDialog = t1;
  switch (status) {
    case "error":
      {
        let t2;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <Icon className="text-destructive-foreground" icon={<Alert />} />;
          $[5] = t2;
        } else {
          t2 = $[5];
        }
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <span className="text-3xs text-destructive-foreground" style={{
            lineHeight: "normal"
          }}>An error occurred</span>;
          $[6] = t3;
        } else {
          t3 = $[6];
        }
        let t4;
        if ($[7] !== refetchAll) {
          t4 = <TooltipTrigger asChild={true}><div className="gap-2xs flex cursor-pointer items-center" onClick={refetchAll}>{t2}{t3}</div></TooltipTrigger>;
          $[7] = refetchAll;
          $[8] = t4;
        } else {
          t4 = $[8];
        }
        let t5;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = <TooltipContent>An error occurred while gathering data for Auto-Deleverage. Click to retry.</TooltipContent>;
          $[9] = t5;
        } else {
          t5 = $[9];
        }
        let t6;
        if ($[10] !== t4) {
          t6 = <Tooltip>{t4}{t5}</Tooltip>;
          $[10] = t4;
          $[11] = t6;
        } else {
          t6 = $[11];
        }
        return t6;
      }
    case "loading":
    case "hidden":
    case "unauthorized":
      {
        return null;
      }
    case "authorized":
      {
        let t2;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <Icon className="text-warning-foreground" icon={<ShieldCheck />} />;
          $[12] = t2;
        } else {
          t2 = $[12];
        }
        let t3;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <span className="text-3xs text-warning-foreground" style={{
            lineHeight: "normal"
          }}>Manage</span>;
          $[13] = t3;
        } else {
          t3 = $[13];
        }
        let t4;
        if ($[14] !== openAutoDeleverageDialog) {
          t4 = <TooltipTrigger asChild={true}><button type="button" onClick={openAutoDeleverageDialog} data-testid="manage-auto-deleverage" className="flex cursor-pointer items-center gap-[2px] rounded-[50px] border-none bg-[rgba(240,162,36,0.18)] py-[3px] pr-[10px] pl-[5px] transition-[background] duration-150 ease-[ease] hover:bg-[rgba(240,162,36,0.28)]">{t2}{t3}</button></TooltipTrigger>;
          $[14] = openAutoDeleverageDialog;
          $[15] = t4;
        } else {
          t4 = $[15];
        }
        let t5;
        if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = <TooltipContent>Disable Auto-Deleverage on this market</TooltipContent>;
          $[16] = t5;
        } else {
          t5 = $[16];
        }
        let t6;
        if ($[17] !== t4) {
          t6 = <Tooltip>{t4}{t5}</Tooltip>;
          $[17] = t4;
          $[18] = t6;
        } else {
          t6 = $[18];
        }
        return t6;
      }
    default:
  }
};
export default memo(AutoDeleverageButton);